import { ChevronUp, RotateCcw } from 'feather-icons-react/build/IconComponents'
import React, { useState, useEffect } from 'react'
import axios from 'axios';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom'
import { setToogleHeader } from '../../../core/redux/action';
import SettingsSidebar from '../settingssidebar';
import Swal from 'sweetalert2';

const GeneralSettings = () => {
    const dispatch = useDispatch();
    const data = useSelector((state) => state.toggle_header);

    const [settings, setSettings] = useState({
        companyName: '',
        email: '',
        phone: '',
        address: '',
        city: '',
        state: '',
        country: '',
        zipCode: '',
    });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchSettings();
    }, []);

    const fetchSettings = async () => {
        try {
            const res = await axios.get("https://avastar-pos-backend.onrender.com/api/settings");
            if (res.data) setSettings(res.data);
        } catch (error) {
            console.error("Error fetching settings:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleChange = (e) => {
        setSettings({ ...settings, [e.target.name]: e.target.value });
    };

    const handleSave = async (e) => {
        e.preventDefault();
        try {
            await axios.put("https://avastar-pos-backend.onrender.com/api/settings", settings);
            Swal.fire('Success', 'Settings updated successfully', 'success');
        } catch (error) {
            Swal.fire('Error', 'Failed to update settings', 'error');
        }
    };

    const renderRefreshTooltip = (props) => (
        <Tooltip id="refresh-tooltip" {...props}>Refresh</Tooltip>
    );
    const renderCollapseTooltip = (props) => (
        <Tooltip id="refresh-tooltip" {...props}>Collapse</Tooltip>
    )

    return (
        <div className="page-wrapper">
            <div className="content settings-content">
                <div className="page-header settings-pg-header">
                    <div className="add-item d-flex">
                        <div className="page-title">
                            <h4>Store Settings</h4>
                            <h6>Manage your restaurant information</h6>
                        </div>
                    </div>
                    <ul className="table-top-head">
                        <li>
                            <OverlayTrigger placement="top" overlay={renderRefreshTooltip}>
                                <Link onClick={fetchSettings}><RotateCcw /></Link>
                            </OverlayTrigger>
                        </li>
                        <li>
                            <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
                                <Link onClick={() => {dispatch(setToogleHeader(!data)) }} className={data ? "active" : ""}><ChevronUp /></Link>
                            </OverlayTrigger>
                        </li>
                    </ul>
                </div>
                <div className="row">
                    <div className="col-xl-12">
                        <div className="settings-wrapper d-flex">
                            <SettingsSidebar/>
                            <div className="settings-page-wrap">
                                {loading ? (
                                    <div className="text-center p-5">Loading settings...</div>
                                ) : (
                                    <form onSubmit={handleSave}>
                                        <div className="setting-title">
                                            <h4>General Information</h4>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="mb-3">
                                                    <label className="form-label">Restaurant Name</label>
                                                    <input type="text" name="companyName" className="form-control" value={settings.companyName} onChange={handleChange} required />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="mb-3">
                                                    <label className="form-label">Contact Email</label>
                                                    <input type="email" name="email" className="form-control" value={settings.email} onChange={handleChange} required />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="mb-3">
                                                    <label className="form-label">Phone Number</label>
                                                    <input type="text" name="phone" className="form-control" value={settings.phone} onChange={handleChange} required />
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <div className="setting-title mt-4">
                                            <h4>Address Details</h4>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="mb-3">
                                                    <label className="form-label">Street Address</label>
                                                    <input type="text" name="address" className="form-control" value={settings.address} onChange={handleChange} required />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="mb-3">
                                                    <label className="form-label">City</label>
                                                    <input type="text" name="city" className="form-control" value={settings.city} onChange={handleChange} required />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="mb-3">
                                                    <label className="form-label">State / Province</label>
                                                    <input type="text" name="state" className="form-control" value={settings.state} onChange={handleChange} required />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="mb-3">
                                                    <label className="form-label">Country</label>
                                                    <input type="text" name="country" className="form-control" value={settings.country} onChange={handleChange} required />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="mb-3">
                                                    <label className="form-label">Postal Code</label>
                                                    <input type="text" name="zipCode" className="form-control" value={settings.zipCode} onChange={handleChange} required />
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <div className="text-end settings-bottom-btn mt-4">
                                            <button type="button" className="btn btn-cancel me-2" onClick={fetchSettings}>Discard</button>
                                            <button type="submit" className="btn btn-submit">Save Restaurant Info</button>
                                        </div>
                                    </form>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default GeneralSettings
